export default __webpack_public_path__ + "static/media/rehack-19.eec06235.jpg";